import {Component} from '@angular/core';
import {FormInlineiframeComponent} from "../form-inlineiframe/form-inlineiframe.component";

@Component({
  selector: 'tig-form-userimporttool',
  templateUrl: '../form-inlineiframe/form-inlineiframe.component.html',
  styleUrls: ['../form-inlineiframe/form-inlineiframe.component.scss']
})
export class FormUserimporttoolComponent extends FormInlineiframeComponent
{

	public static IFRAME_ID = 'iframe-userimporttool'

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormUserimporttoolComponent.IFRAME_ID;
	} // end function getIFrameID

}
